import React from "react";
import { Link } from "react-router-dom";

export const PublicOAuthLanding = () => {
  return (
    <main className="min-h-screen bg-[#171B24] px-5 py-10 text-slate-100" data-testid="oauth-public-home">
      <div className="mx-auto flex max-w-5xl flex-col">
        <header className="flex items-center justify-between border-b border-white/15 pb-6">
          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.22em] text-[#C49A58]">Femmes Marketing</p>
            <p className="mt-1 text-lg font-semibold">Business Studio Suite</p>
          </div>
          <Link
            to="/app"
            className="rounded-full border border-[#C49A58] px-4 py-2 text-sm font-medium text-[#F5DEB3]"
            data-testid="oauth-public-login"
          >
            Zur Anmeldung
          </Link>
        </header>

        <section className="max-w-3xl py-20">
          <p className="mb-5 text-sm font-semibold uppercase tracking-[0.18em] text-[#C49A58]">Unternehmenssoftware für den DACH-Raum</p>
          <h1 className="max-w-2xl font-[Playfair_Display] text-4xl font-semibold leading-tight sm:text-5xl">
            Business Studio Suite
          </h1>
          <p className="mt-7 max-w-2xl text-lg leading-8 text-slate-300">
            Die Business Studio Suite bündelt Angebots- und Rechnungswesen, CRM, Reiseplanung,
            Projekt- und Workforce-Prozesse, Ausgaben und Dokumente sowie Commerce in einer
            mandantengetrennten Arbeitsumgebung für Unternehmen.
          </p>
          <p className="mt-5 max-w-2xl text-base leading-7 text-slate-300">
            Innerhalb des CRM kann ein Unternehmen sein eigenes Google- beziehungsweise Gmail-Konto
            freiwillig verbinden. Der Zugriff erfolgt erst nach ausdrücklicher Autorisierung durch eine
            berechtigte Nutzerin oder einen berechtigten Nutzer der jeweiligen Organisation.
          </p>
        </section>

        <section className="grid gap-4 border-t border-white/15 py-8 text-sm text-slate-300 sm:grid-cols-2 lg:grid-cols-4">
          <Link className="underline decoration-[#C49A58] underline-offset-4" to="/datenschutz" data-testid="oauth-public-privacy">
            Datenschutzerklärung
          </Link>
          <Link className="underline decoration-[#C49A58] underline-offset-4" to="/google-api-datenschutz" data-testid="oauth-public-google-api-privacy">
            Google-API-Datenschutzhinweise
          </Link>
          <Link className="underline decoration-[#C49A58] underline-offset-4" to="/nutzungsbedingungen" data-testid="oauth-public-terms">
            Nutzungsbedingungen / AGB
          </Link>
          <Link className="underline decoration-[#C49A58] underline-offset-4" to="/impressum" data-testid="oauth-public-imprint">
            Impressum
          </Link>
        </section>
      </div>
    </main>
  );
};

export default PublicOAuthLanding;
